module.exports = __webpack_public_path__ + "img/feel_select_icon.c3b5454a.svg";